import { useSuspenseQuery } from '@tanstack/react-query';

import { getGuestQuizSetBuildInfo, getQuizSetBuildInfo } from '@/api';
import { useUser } from '@/lib/auth';

/**
 * Build 페이지 정보를 가져오는 훅
 *
 * - 인증된 유저: `/quizsets/build-info` (유저별 데이터 포함)
 * - 게스트 유저: `/quizsets/build-info/guest` (공용 데이터만)
 *
 * gcTime: 0 설정으로 항상 최신 데이터 보장
 */
export const useBuildInfoQuery = () => {
  const { user } = useUser();
  const isGuest = !user;

  return useSuspenseQuery({
    queryKey: isGuest
      ? ['/quizsets/build-info/guest']
      : ['/quizsets/build-info'],
    queryFn: ({ signal }) =>
      isGuest
        ? getGuestQuizSetBuildInfo(undefined, signal)
        : getQuizSetBuildInfo(undefined, signal),
    gcTime: 0,
  });
};
